// utils/extractTemplateContent.ts


// interface TaskItem extends Node {
//   attrs: { checked: boolean };
// }
import {Doc, Node, ExtractedInitial} from '../type';

export function extractTemplateContent(doc: Doc): { textBeforeHorizontalRule: string; codeBlockTexts: string[]; taskList: string[] } {
  let textBeforeHorizontalRule = '';
  let codeBlockTexts: string[] = [];
  let taskList: string[] = [];

  let foundHorizontalRule = false;

  for (const node of doc.content) {
    if (node.type === 'horizontalRule') {
      foundHorizontalRule = true;
      continue;
    }

    if (!foundHorizontalRule) {
      if (node.type === 'paragraph' && node.content) {
        for (const childNode of node.content) {
          if (childNode.type === 'text' && childNode.text) {
            textBeforeHorizontalRule += childNode.text + ' ';
          }
        }
      }
      if (node.type === 'codeBlock' && node.content) {
        let codeBlockTextBeforeHorizontal = '';
        for (const childNode of node.content) {
          if (childNode.type === 'text' && childNode.text) {
            codeBlockTextBeforeHorizontal += childNode.text + ' ';
          }
        }
        textBeforeHorizontalRule += '\n' + codeBlockTextBeforeHorizontal.trim() ;
      }
    } else {
      if (node.type === 'codeBlock' && node.content) {
        let codeBlockText = '';
        for (const childNode of node.content) {
          if (childNode.type === 'text' && childNode.text) {
            codeBlockText += childNode.text + ' ';
          }
        }
        codeBlockTexts.push(codeBlockText.trim());
      } else if (node.type === 'taskList' && node.content) {
        for (const taskItem of node.content) {
          if (taskItem.type === 'taskItem' && taskItem.attrs && taskItem.attrs.checked && taskItem.content) {
            for (const childNode of taskItem.content) {
              if (childNode.type === 'paragraph' && childNode.content) {
                for (const textNode of childNode.content) {
                  if (textNode.type === 'text' && textNode.text) {
                    taskList.push(textNode.text);
                  }
                }
              }
            }
          }
        }
      }
    }
  }


  // 清理孤立代理项
  const removeLoneSurrogates = (str: string) => str.replace(/[\ud800-\udbff](?![\udc00-\udfff])|[\udc00-\udfff](?<![\ud800-\udbff])/g, '');

  textBeforeHorizontalRule = removeLoneSurrogates(textBeforeHorizontalRule.trim());
  codeBlockTexts = codeBlockTexts.map(text => removeLoneSurrogates(text));
  taskList = taskList.map(text => removeLoneSurrogates(text));

  return {
    textBeforeHorizontalRule: textBeforeHorizontalRule.trim(),
    codeBlockTexts,
    taskList
  };
}


export function extractData(doc: Doc): { textBeforeHorizontalRule: string; codeBlockTexts: string[]; taskList: Node[] } {
  let textBeforeHorizontalRule = '';
  let codeBlockTexts: string[] = [];
  let taskList: Node[] = [];

  let foundHorizontalRule = false;

  for (const node of doc.content) {
    if (node.type === 'horizontalRule') {
      foundHorizontalRule = true;
      continue;
    }

    if (!foundHorizontalRule) {
      if (node.type === 'paragraph' && node.content) {
        for (const childNode of node.content) {
          if (childNode.type === 'text' && childNode.text) {
            textBeforeHorizontalRule += childNode.text + ' ';
          }
        }
      }
    } else {
      if (node.type === 'codeBlock' && node.content) {
        let codeBlockText = '';
        for (const childNode of node.content) {
          if (childNode.type === 'text' && childNode.text) {
            codeBlockText += childNode.text + ' ';
          }
        }
        codeBlockTexts.push(codeBlockText.trim());
      } else if (node.type === 'taskList' && node.content) {
        taskList = node.content;
      }
    }
  }

  // 清理孤立代理项
  const removeLoneSurrogates = (str: string) => str.replace(/[\ud800-\udbff](?![\udc00-\udfff])|[\udc00-\udfff](?<![\ud800-\udbff])/g, '');

  textBeforeHorizontalRule = removeLoneSurrogates(textBeforeHorizontalRule.trim());
  codeBlockTexts = codeBlockTexts.map(text => removeLoneSurrogates(text));
  // taskList = taskList.map(text => removeLoneSurrogates(text));

  return {
    textBeforeHorizontalRule: textBeforeHorizontalRule.trim(),
    codeBlockTexts,
    taskList
  };
}

// 提取 TemplateInitail content 数据，千问实现
interface DocContent {
  type: string;
  attrs?: { [key: string]: any };
  content?: DocContent[];
  text?: string;
  marks?: { type: string }[];
}


export function extractTemplateInitial_bug(doc: { type: string; content: DocContent[] }): ExtractedInitial {
  const extracted: ExtractedInitial = {
    title: '',
    description: '',
    placeHolder: '',
    suggestions: [],
    disable: false,
    disableMentor: false,
    jsonBlocks: [],
  };

  console.log(`extractTemplateInitial doc:`, doc);

  for (const item of doc.content) {
    switch (item.type) {
      case 'heading':
        if (item.attrs && item.content) {
          const level = item.attrs.level;
          const text = item.content[0].text || '';
          switch (level) {
            case 1:
              extracted.title = text;
              break;
            case 2:
              extracted.description = text;
              break;
            case 3:
              extracted.placeHolder = text;
              break;
          }
        }
        break;

      case 'bulletList':
        if (item.content) {
          for (const listItem of item.content) {
            if (listItem.type === 'listItem' && listItem.content) {
              const texts: string[] = [];
              for (const paragraph of listItem.content) {
                if (paragraph.type === 'paragraph' && paragraph.content) {
                  for (const text of paragraph.content) {
                    if (text.type === 'text') {
                      texts.unshift(text.text || '');
                      // if (text.marks && text.marks.some(mark => mark.type === 'bold')) {
                      //   // 如果有 bold 标记，放在后面
                      //   texts.push(text.text || '');
                      // } else {
                      //   // 没有 bold 标记，直接添加
                      //   texts.unshift(text.text || '');
                      // }
                    }
                  }
                }
              }
              extracted.suggestions = texts;
            }
          }
        }
        break;

      case 'paragraph':
        if (item.content) {
          for (const text of item.content) {
            if (text.type === 'text' && text.text === 'disable') {
              extracted.disable = true;
              // extracted.disable = text.marks ? text.marks.some(mark => mark.type === 'strike') : false;
            }
          }
        }
        break;
    }
  }

  return extracted;
}



interface Mark {
  type: string;
}

export function extractTemplateInitial(doc: { type: string; content: any[] }): ExtractedInitial {
  const jsonBlocks: string[] = [];
  const extracted: ExtractedInitial = {
    title: '',
    description: '',
    placeHolder: '',
    suggestions: [],
    disable: false,
    disableMentor: false,
    jsonBlocks: [],
  };

  // console.log(`extractTemplateInitial doc:`, JSON.stringify(doc, null, 2));

  if (typeof doc === 'string') {
    try {
      doc = JSON.parse(doc);
    } catch (e) {
      throw new Error('Invalid document structure: doc is a malformed JSON string');
    }
  }


  if (!doc || typeof doc !== 'object') {
    throw new Error('Invalid document structure: doc is not valid');
  }

  if (!Array.isArray(doc.content)) {
    throw new Error('Invalid document structure:doc.content is not valid');
  }

  for (const item of doc.content) {
    // console.log(`Markdown Processing item:`, JSON.stringify(item, null, 2)); // 调试信息

    switch (item.type) {
      case 'heading':
        if (item.attrs && item.content && Array.isArray(item.content)) {
          const level = item.attrs.level;
          const text = item.content[0].text || '';
          console.log(`Heading level ${level}:`, text); // 调试信息
          switch (level) {
            case 1:
              extracted.title = text;
              break;
            case 2:
              extracted.description = text;
              break;
            case 3:
              extracted.placeHolder = text;
              break;
          }
        }
        break;

      case 'bulletList':
        if (item.content && Array.isArray(item.content)) {
          for (const listItem of item.content) {
            // console.log(`Processing list item:`, JSON.stringify(listItem, null, 2)); // 调试信息
            if (listItem.type === 'listItem' && listItem.content && Array.isArray(listItem.content)) {
              const texts: string[] = [];
              for (const paragraph of listItem.content) {
                // console.log(`Processing paragraph:`, JSON.stringify(paragraph, null, 2)); // 调试信息
                if (paragraph.type === 'paragraph' && paragraph.content && Array.isArray(paragraph.content)) {
                  for (const text of paragraph.content) {
                    // console.log(`Processing text:`, JSON.stringify(text, null, 2)); // 调试信息
                    if (text.type === 'text') {
                      if (text.marks && Array.isArray(text.marks) && text.marks.some((mark:any) => mark.type === 'bold')) {
                        // 如果有 bold 标记，放在后面
                        texts.push(text.text || '');
                      } else {
                        // 没有 bold 标记，直接添加
                        texts.unshift(text.text || '');
                      }
                    }
                  }
                }
              }
              if(texts && texts.join(' ').trim().length > 0) extracted.suggestions.push(texts.join(' ')); // 将数组转换为字符串
            }
          }
        }
        break;

      case 'paragraph':
        if (item.content && Array.isArray(item.content)) {
          for (const text of item.content) {
            // console.log(`Processing paragraph text:`, JSON.stringify(text, null, 2)); // 调试信息
            if (text.type === 'text' && text.text === 'disable') {
              if (text.marks && text.marks.find((mark:Mark) => mark.type === "strike")) {
                extracted.disable = true;
              }
            }
            if (text.type === 'text' && text.text === 'disableMentor') {
              if (text.marks && text.marks.find((mark:Mark) => mark.type === "strike")) {
                extracted.disableMentor = true;
              }
            }
          }
        }
        break;

      case 'codeBlock':
        if (item.content && Array.isArray(item.content)) {
          let codeBlockText = '';
          for (const con of item.content) {
            // console.log(`Processing paragraph text:`, JSON.stringify(text, null, 2)); // 调试信息
            if (con.type === 'text' && con.text) {
              codeBlockText += con.text + ' ';
            }
          }
          extracted.jsonBlocks.push(codeBlockText.trim());
        }
        break;

      default:
        console.warn(`Unhandled content type: ${item.type}`); // 调试信息
    }
  }

  return extracted;
}

// 示例调用
// const exampleDoc = {
//   type: "doc",
//   content: [
//     { type: "heading", attrs: { level: 1 }, content: [{ type: "text", text: "模版标题" }] },
//     { type: "heading", attrs: { level: 2 }, content: [{ type: "text", text: "任务描述 => 可点击左上角编辑" }] },
//     { type: "heading", attrs: { level: 3 }, content: [{ type: "text", text: "placeHolder" }] },
//     { type: "bulletList", attrs: { tight: true }, content: [
//       { type: "listItem", content: [{ type: "paragraph", content: [{ type: "text", text: "建议指令1 => **可编辑模版内容修改**" }] }] },
//       { type: "listItem", content: [{ type: "paragraph", content: [{ type: "text", text: "建议指令2 => **可编辑模版内容修改**" }] }] }
//     ]},
//     { type: "paragraph", content: [{ type: "text", marks: [{ type: "strike" }], text: "disable" }] }
//   ]
// };

// console.log(extractTemplateInitial(exampleDoc));
















/*

{"type":"doc","content":[{"type":"heading","attrs":{"level":1},"content":[{"type":"text","text":"模版标题"}]},{"type":"heading","attrs":{"level":2},"content":[{"type":"text","text":"任务描述"}]},{"type":"heading","attrs":{"level":3},"content":[{"type":"text","text":"placeHolder"}]},{"type":"bulletList","attrs":{"tight":true},"content":[{"type":"listItem","content":[{"type":"paragraph","content":[{"type":"text","text":"出一套**7年级难度的数学练习题**"}]}]},{"type":"listItem","content":[{"type":"paragraph","content":[{"type":"text","text":"出一套**性格测试题**"}]}]}]},
{"type":"paragraph","content":[{"type":"text","marks":[{"type":"strike"}],"text":"disable"}]}]}


// 示例数据
const data = {
  type: "doc",
  content: [
    {
      type: "heading",
      attrs: {
        level: 1
      },
      content: [{ type: "text", text: "做题" }]
    },
    {
      type: "heading",
      attrs: {
        level: 2
      },
      content: [{ type: "text", text: "随便各种题目，信手拈来" }]
    },
    {
      type: "heading",
      attrs: {
        level: 3
      },
      content: [{ type: "text", text: "placeholder" }]
    },
    {
      type: "bulletList",
      attrs: {
        tight: true
      },
      content: [
        {
          type: "listItem",
          content: [
            {
              type: "paragraph",
              content: [
                { type: "text", text: "出一套" },
                { type: "text", marks: [{ type: "bold" }], text: "7年级难度的数学练习题" }
              ]
            }
          ]
        },
        {
          type: "listItem",
          content: [
            {
              type: "paragraph",
              content: [
                { type: "text", text: "出一套" },
                { type: "text", marks: [{ type: "bold" }], text: "性格测试题" }
              ]
            }
          ]
        }
      ]
    },
    {
      type: "paragraph",
      content: [
        {
          type: "text",
          marks: [{ type: "strike" }],
          text: "disable"
        }
      ]
    }
  ]
};
*/

// 提取数据
// const result = extractData(data);
// console.log(result);
